import "../Lightcast.scss";
import translate from "@/i18n/translate";
import { useIntl } from "react-intl";
import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import WidgetLoader from "@/features/common/elements/WidgetLoader";
import ApiError from "../../common/elements/ApiError";
import { IndustryOrOccupation, OccupationChartProps } from "../Interface";

export interface TopGrowingOccupationsProps {
  occupations: null | IndustryOrOccupation[];
  loader: boolean;
  forHtml?: boolean;
}

export default function TopGrowingOccupations({
  occupations,
  loader,
  forHtml
}: TopGrowingOccupationsProps) {
  return (
    <div className={forHtml ? "top-growing-occupations" : "paper-card"}>
      <div className="header">
        <div className="info">
          <h3 className={forHtml ? "html-title" : "title"}>
            {translate("app.topGrowingOccp.topThreeGrowing")}
          </h3>
          <p className={forHtml ? "html-desc" : "description -des"}>
            {translate("app.topGrowingOccp.reviewTopOccp")}
          </p>
        </div>
      </div>
      <div className="body">
        {occupations && <OccupationsChart occupations={occupations} />}

        {loader && !occupations && (
          <WidgetLoader
            loaderContainerClasses="loader"
            loaderClasses="content"
          />
        )}
        {!loader && !occupations && <ApiError />}
      </div>
    </div>
  );
}

function useGetPopoverTextLabel(changeVal: string) {
  return useIntl().formatMessage(
    {
      id: "app.bottomGrowingOccp.popoverTextLabel"
    },
    {
      changeJob: changeVal.toLocaleString()
    }
  );
}

const GetPopoverTextLabel = (changeVal: string) => {
  return useGetPopoverTextLabel(changeVal);
};

const OccupationsChart = ({ occupations }: OccupationChartProps) => {
  const chartLabel = useIntl().formatMessage({
    id: "app.topGrowingOccp.topThreeGrowing"
  });
  return (
    <WmChart
      label={chartLabel}
      labelPosition="none"
      chartType="bar6"
      valueFormat="amount"
      showGrid={true}
      labelWidth="120px"
      print-mode={true}
    >
      {occupations.map((row: IndustryOrOccupation) => {
        return (
          <WmChartSlice
            key={row?.name}
            amount={String(row?.change)}
            legend={row?.name}
            popoverText={GetPopoverTextLabel(String(row?.change))}
            popoverTitle={row?.changePercentage}
          ></WmChartSlice>
        );
      })}
    </WmChart>
  );
};
